import { AvailableModules } from 'generated/featureDefinitions'

import type { ModuleAvailabilityType } from 'modules/core/hooks/useModuleAvailability'
import { isModuleAvailabilityEnabled } from 'modules/core/lib/isModuleAvailabilityEnabled'

export const timeoffModuleEnabledInAvailabilities = (
  moduleAvailabilities: ModuleAvailabilityType[]
) => {
  return isModuleAvailabilityEnabled(moduleAvailabilities, AvailableModules.timeoff)
}
